import { ScaleTime, ScaleLinear } from 'd3-scale';
import { select } from 'd3-selection';
import { curveMonotoneX, line } from 'd3-shape';

import type { WindTimestep } from 'types/wind';

import styles from './LiveWindLineGraph.module.scss';

const setupForecastedWindGraph = (
  x: ScaleTime<number, number>,
  y: ScaleLinear<number, number>,
  data: Array<WindTimestep>,
) => {
  const graphSvg = select<HTMLDivElement, WindTimestep>(`.${styles.graphSvg}`);

  const path = line<WindTimestep>()
    .x((d) => x(d.timestamp))
    .y((d) => y(d.speed))
    .curve(curveMonotoneX);

  graphSvg.append('path').attr('class', styles.forecastedWindLine).attr('d', path(data));
};

export default setupForecastedWindGraph;
